import { api } from './palmPayApi';
import type { SignupRequest, LoginRequest, AuthResponse } from '../types';
import type { OTPRequest, VerifyOTPRequest } from '../types';

// Auth API functions
export const signup = async (data: SignupRequest): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>('/auth/signup', data);
  return response.data;
};

export const login = async (data: LoginRequest): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>('/auth/login', data);
  return response.data;
};

export const logout = async (): Promise<void> => {
  await api.post('/auth/logout');
};

export const resetPassword = async (data: { userId?: string; }): Promise<any> => {
  const response = await api.post('/auth/reset-password', data);
  return response.data;
};

export const changePassword = async (data: { userId: string; originalPassword: string; newPassword: string }): Promise<any> => {
  const response = await api.post('/auth/change-password', data);
  return response.data;
};

export const updateProfile = async (data: { userId: string; username: string }): Promise<any> => {
  const response = await api.post('/auth/update-profile', data);
  return response.data;
};

export const getUsers = async (): Promise<{ users: any[] }> => {
  const response = await api.get<{ users: any[] }>('/auth/users');
  return response.data;
};

// OTP API
export const sendSmsOtp = async (data: OTPRequest): Promise<{ success: boolean; message: string }> => {
  const response = await api.post<{ success: boolean; message: string }>('/send-sms-otp', data);
  return response.data;
};

export const sendEmailOtp = async (data: OTPRequest): Promise<any> => {
  const response = await api.post<{ success: boolean; message: string }>('/email-otp/send', data);
  return response.data;
};

export const verifySmsOtp = async (data: VerifyOTPRequest): Promise<{ success: boolean; message: string }> => {
  const response = await api.post<{ success: boolean; message: string }>('/verify-sms-otp', data);
  return response.data;
};

export const verifyEmailOtp = async (data: VerifyOTPRequest): Promise<{ success: boolean; message: string }> => {
  const response = await api.post<{ success: boolean; message: string }>('/email-otp/verify', data);
  return response.data;
};

// Auth utility functions
export const hasCompletedOnboarding = (): boolean => {
  return localStorage.getItem('onboardingCompleted') === 'true';
};

export const setOnboardingCompleted = (): void => {
};

export const isUserLoggedIn = (): boolean => {
  return localStorage.getItem('isLoggedIn') === 'true';
};

export const setUserLoggedIn = (userData: any = {}): void => {
  localStorage.setItem('isLoggedIn', 'true');
  if (userData) {
    localStorage.setItem('userData', JSON.stringify(userData));
  }
};

export const isPalmRegistered = (): boolean => {
  return localStorage.getItem('palmRegistered') === 'true';
};

export const setPalmRegistered = (): void => {
  localStorage.setItem('palmRegistered', 'true');
};

export const getUserData = (): any => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

export const logoutUser = (): void => {
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userData');
  localStorage.removeItem('palmRegistered');
};

export const completeLogout = (): void => {
  localStorage.clear();
};

export const getInitialRoute = (): string => {
  const onboardingDone = hasCompletedOnboarding();
  const loggedIn = isUserLoggedIn();
  const palmRegistered = isPalmRegistered();

  if (!onboardingDone) {
    return '/onboarding';
  }

  if (!loggedIn) {
    return '/auth';
  }

  if (!palmRegistered) {
    return '/palm-register';
  }

  return '/home';
};

